import { memo } from 'react';
import type { CustomerDTO } from '@six-pockets/shared';
import { Avatar } from '@/components/ui';
import { RowActions } from '@/features/manage/components/RowActions';
import { formatPhone } from '@/utils/format';
import styles from '@/styles/components/CustomerRow/style.scss';

interface CustomerRowProps {
  customer: CustomerDTO;
  onEdit: (customer: CustomerDTO) => void;
  /** Admin only; left out for the manager, who can edit but not delete. */
  onDelete?: (customer: CustomerDTO) => void;
}

/** One customer on the Customers page, one line: avatar · name · mobile · edit (· delete). */
export const CustomerRow = memo(function CustomerRow({ customer, onEdit, onDelete }: CustomerRowProps) {
  return (
    <li className={styles.row}>
      <Avatar name={customer.name} size="sm" />
      <span className={styles.name} title={customer.name}>
        {customer.name}
      </span>
      <span className={styles.phone}>{formatPhone(customer.phone)}</span>
      <RowActions name={customer.name} onEdit={() => onEdit(customer)} onDelete={onDelete && (() => onDelete(customer))} />
    </li>
  );
});
